module.exports = __webpack_public_path__ + "354f9c214d3c7bdd3588b0202bd5eb8f.jpg";